import {
  IClientTarget,
  ISiteTarget,
  isClientTarget,
  isSiteTarget,
  isTenantTarget,
} from "wombat-global/src/typings";
import { pageRoutePath } from "wombat-global/src/utilities/page-route.mjs";

export const ROUTES = import.meta.glob("../pages/**/[a-zA-Z0-9]*.tsx");
// oxlint-disable-next-line typescript/no-explicit-any
export const PRESERVED = import.meta.glob<any>("../pages/(_app|404).tsx", {
  eager: true,
});

export const routeMap = Object.keys(ROUTES).reduce(
  (routes, key) => {
    if (key.includes("_")) {
      return routes;
    }
    routes[key] = pageRoutePath(key);

    return routes;
  },
  {} as Record<keyof typeof ROUTES, string>,
);

export const regularRoutes = Object.values<string>(routeMap || {});

// oxlint-disable-next-line typescript/no-explicit-any
export const preservedRoutes: Record<string, any> = Object.keys(
  PRESERVED,
).reduce((routes, key) => {
  const path = key.replace(/\.\.\/pages\/|\.tsx$/g, "");
  // todo add path mapping for no ending / and / (training slash)
  return { ...routes, [path]: PRESERVED[key]?.default };
}, {});

export function webLinkPath(target: IClientTarget | ISiteTarget): string {
  if (isSiteTarget(target)) {
    return `/site/${target.siteId}`;
  }
  const { tenantId, divisionId } = target;
  if (isTenantTarget(target)) {
    if (tenantId && divisionId) {
      return `/t/${tenantId}/d/${divisionId}`;
    }
    return `/t/${tenantId}`;
  }

  const { orgId } = target;
  if (divisionId && tenantId) {
    return `/o/${orgId}/t/${tenantId}/d/${divisionId}`;
  }

  if (tenantId) {
    return `/o/${orgId}/t/${tenantId}`;
  }
  return `/o/${orgId}`;
}

export function getTargetFromParams(
  params: Record<string, string>,
): IClientTarget | ISiteTarget | undefined {
  if (isTenantTarget(params)) {
    return {
      tenantId: params.tenantId,
      divisionId: params.divisionId,
    };
  }

  if (isClientTarget(params)) {
    return {
      orgId: params.orgId,
      tenantId: params.tenantId,
      divisionId: params.divisionId,
    };
  }

  if (isSiteTarget(params)) {
    return { siteId: params.siteId };
  }
  return undefined;
}
